import { NgModule } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { VerbalCertificationFormModule } from "../verbal-certification-form/verbal-certification-form.module";
import { WrittenCertificationFormModule } from "../written-certification-form/written-certification-form.module";
import { CertificationReceivedModalV2 } from "./certification-received-v2";

@NgModule({
  declarations: [CertificationReceivedModalV2],
  imports: [
    CommonComponentsModule,
    TranslateModule.forChild(),
    IonicPageModule.forChild(CertificationReceivedModalV2),
    FontAwesomeModule,
    VerbalCertificationFormModule,
    WrittenCertificationFormModule,
  ],
})
export class CertificationReceivedModuleV2 {}



// WEBPACK FOOTER //
// ./src/certification/forms/certification-received-v2/certification-received-v2.module.ts